import React from "react";
import IsSeries from "./SeriesChecker";
import UploadSeasonContent from "./UploadSeasonContent";
import UploadSeriesMetaData from "./UploadSeriesMetaData";
import Series from "./Series";
import Seasons from "./Seasons";

const SeriesHandler = ({ formik, selectedSeasonsList, isSeries }) => {
  const handleIsSeries = () => {
    if (isSeries) {
      return (
        <>
          <Series formik={formik} />
          {/* <UploadSeriesMetaData formik={formik} /> */}
          <Seasons formik={formik} />
        </>
      );
    }
    return null;
  };

  return (
    <>
      <IsSeries
        type="Do you want to upload entire series (batch file)?"
        formik={formik}
      />
      {handleIsSeries()}
      {/* {selectedSeasonsList?.length > 0 &&
        selectedSeasonsList.map((season) => (
          <UploadSeasonContent
            key={season.id}
            seasonId={season.id}
            title={season.title}
          />
        ))} */}
    </>
  );
};

export default SeriesHandler;
